import { client } from '../client';

interface Response {
  url: string;
}

type PrecheckData = {
  audio?: boolean;
  camera?: boolean;
};

export const createAuditTrail = async (
  caseId: number,
  audioPermission: boolean,
  cameraPermission: boolean,
): Promise<Response> => {
  const precheckData: PrecheckData = {
    audio: audioPermission,
    camera: cameraPermission,
  };
  const { data } = await client.post<Response>(`/cases/${caseId}/join_video_room/precheck`, precheckData);

  return data;
};
